import { useQuery } from '@tanstack/react-query';
import { rollingReactionQueryKey } from 'queries/rollingReaction/queryKey';
import { RollingReactionApi } from 'api/ApiHelper';

export const usePostRollingReactionsQuery = (rollingIds: number[]) =>
  useQuery({
    queryKey: rollingReactionQueryKey.rollings(rollingIds),
    queryFn: async () => RollingReactionApi.getMyReactions(rollingIds),
  });
